export default "__VITE_ASSET__BoTgyP23__"